import exhaustivnessCheck from 'common/utils/exhaustivnessCheck';
import produce from 'immer';
import { Reducer } from 'redux';
import { UserWalletsActions, UserClientsActions } from './actions';
import {
  WalletsState,
  ClientsState,
  defaultClientsState,
  defaultWalletsState,
} from './states';

// #region Wallet
export const walletsReducer: Reducer<WalletsState, UserWalletsActions> = (
  state = defaultWalletsState,
  action
) =>
  produce(state, (draft) => {
    switch (action.type) {
      case 'wallets/user/started':
        draft.pending = true;
        return;

      case 'wallets/user/finished':
        draft.pending = false;
        draft.wallets = action.wallets;
        draft.count = action.count || 0;
        draft.next = action.next;
        draft.previous = action.previous;
        draft.error = action.error;
        return;

      default:
        exhaustivnessCheck(action);
    }
  });
// #endregion

// #region Client
export const clientsReducer: Reducer<ClientsState, UserClientsActions> = (
  state = defaultClientsState,
  action
) =>
  produce(state, (draft) => {
    switch (action.type) {
      case 'clients/user/started':
        draft.pending = true;
        return;

      case 'clients/user/finished':
        draft.pending = false;
        draft.clients = action.clients;
        draft.count = action.count || 0;
        draft.next = action.next;
        draft.previous = action.previous;
        draft.error = action.error;
        return;

      default:
        exhaustivnessCheck(action);
    }
  });
// #endregion
